<div class="license-report-container">

    <!-- Nested view  -->
    <router-outlet></router-outlet>

</div>
